import { VueRenderer } from '@tiptap/vue-3';
import PopUpEditLink from '../popups/PopUpEditLink';
import tippy from 'tippy.js';

export default {
  data() {
    return {
      component: null,
      popup: null,
    };
  },

  methods: {
    showPopup(props) {
      this.component = new VueRenderer(PopUpEditLink, {
        props: { ...props, popup: {}, component: {} },
        editor: props.editor,
      });

      const rects = document.body.getBoundingClientRect();
      // use tippy to attach component on body element
      this.popup = tippy('body', {
        getReferenceClientRect: () => ({
          ...rects,
        }),
        appendTo: () => document.body,
        content: this.component.ref.$el,
        showOnCreate: true,
        interactive: true,
        placement: 'top-start',
        trigger: 'manual',
        maxWidth: 'none',
        animation: 'none',
        role: 'poper',
      });

      // update props with popup and component instance
      this.component.updateProps({ ...props, popup: this.popup, component: this.component });
    },
  },
};
